module.exports = __webpack_public_path__ + "static/img/egg_b_09.d6d6015.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/b/egg_b_09.png
// module id = dVpw
// module chunks = 1